var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import "../ui.css";
import { useDataUiTheme } from "../utility/getDataUiTheme";
import { formatter } from "../utility/formatter";
export var RadixInput = React.forwardRef(function (_a, ref) {
    var icon = _a.icon, rightElement = _a.rightElement, wrapperClassName = _a.wrapperClassName, iconClassName = _a.iconClassName, className = _a.className, label = _a.label, id = _a.id, props = __rest(_a, ["icon", "rightElement", "wrapperClassName", "iconClassName", "className", "label", "id"]);
    var uiTheme = useDataUiTheme();
    var ariaInvalid = props["aria-invalid"];
    var isInvalid = ariaInvalid === true || ariaInvalid === "true";
    var inputClassName = [
        "radix-input",
        icon ? "radix-input--with-icon" : null,
        rightElement ? "radix-input--with-right-element" : null,
        className,
    ].filter(Boolean).join(" ");
    return (React.createElement("div", { className: ["radix-input-wrapper", wrapperClassName].filter(Boolean).join(" "), "data-invalid": isInvalid ? "true" : undefined, "data-ui-theme": uiTheme },
        label ? React.createElement("label", { className: "radix-input-label", htmlFor: id }, formatter.toSentenceCase(label)) : null,
        React.createElement("div", { className: "radix-input-control" },
            //This needs to be here to accommodate payment processors that do not allow id attribute.
            id ?
                React.createElement("input", __assign({ ref: ref, id: id, className: inputClassName }, props))
                :
                    React.createElement("input", __assign({ ref: ref, className: inputClassName }, props)),
            icon ? React.createElement("span", { className: ["radix-input-icon", iconClassName].filter(Boolean).join(" "), "aria-hidden": "true" }, icon) : null,
            rightElement ? React.createElement("div", { className: "radix-input-right-element" }, rightElement) : null)));
});
RadixInput.displayName = "RadixInput";
